import { z } from 'zod';

export const setSocialChannelStatusV1RequestSchema = z.object({
  channelId: z.number(),
  status: z.enum(['active', 'disabled']),
});

export type ISetSocialChannelStatusV1Request = z.infer<
  typeof setSocialChannelStatusV1RequestSchema
>;
